import type {ISeoAndRedirectOptions} from "~/shared/interfaces/seo";
import customFetch from "~/composables/custom-fetch";
import serverConfig from "~/server/config";

async function getSeoData(requestUrl:string) {
  const seo = {
    h1: '',
    title: '',
    description: '',
    type: 'website',
    url: '',
    siteName: 'Sotrans Parts',
    robots: 'index, follow',
  }

  const query = {
    url: requestUrl
  }

  const { data, refresh } = useAsyncData('fetchData'+requestUrl, async() => {
    const { seo } = serverConfig;
    const { data, status } = await customFetch<ISeoAndRedirectOptions>(seo.getSeo({
      query
    }));

    return data
  }, {
    lazy: false,
    getCachedData() {
      return null
    }
  })

  if(!data?.value) await refresh()

  if(data?.value) {
    setTimeout(() => {
      if(data.value?.redirect?.to) {
        return navigateTo(data.value.redirect.to.replace('api.', ''), {redirectCode: 301, external: true})
      }
    })
    if(data?.value?.seo) {
      return data?.value?.seo
    }
    return seo
  }

  return seo
}

export default getSeoData
